import {
  IoBriefcaseOutline,
  IoCodeSlashOutline,
  IoMegaphoneOutline,
  IoBagOutline,
  IoSchoolOutline,
} from 'react-icons/io5';

export const ONBOARDING_STEP_ORDER = ['setup', 'prepare'];

export const businessOptions = [
  { label: 'Agency', icon: IoMegaphoneOutline },
  { label: 'Recruiting', icon: IoSchoolOutline },
  { label: 'SaaS', icon: IoCodeSlashOutline },
  { label: 'Consulting', icon: IoBriefcaseOutline },
  { label: 'Ecommerce', icon: IoBagOutline },
];

export const roleOptions = ['Founder', 'CEO', 'Manager', 'Marketer', 'BDR / SDR', 'Internee'];

export const goalOptions = [
  'Find Leads',
  'More Meetings',
  'More Clients',
  'More Revenue',
  'Automate Outreach',
  'AI Personalization',
];

export const prepareItems = ['Account Created', 'Email Verified', 'Workspace Created', 'AI Ready'];

export const mapGoalToUseFor = goal => {
  const mapping = {
    'Find Leads': 'data_scraping',
    'More Meetings': 'linkediv_marketing',
    'More Clients': 'email_marketing',
    'More Revenue': 'email_marketing',
    'Automate Outreach': 'linkediv_marketing',
    'AI Personalization': 'ai_agents',
  };
  return mapping[goal] ? [mapping[goal]] : [goal];
};

export const buildWorkspaceSetupPayload = ({ role, goal, business }) => ({
  companyRole: role,
  useFor: mapGoalToUseFor(goal),
  heardAboutUs: business ? [business] : [],
});
